exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CollapseVcDemo[data-v-bc5cef08]{width:100%}", ""]);

// exports
